import Avatar from './LegacyAvatarAdapter';

export default Avatar;
